import store from '@/store/store';
import { getDevice, isApp, isLocalHost } from './environmentService';
import { UPDATE_AUTH } from '@/store/modules/authenticationContext';
import { exception } from '@/appinsights/logging/ApplicationInsightLog';

export const setVersion = () => {
	try {
		if (isLocalHost) {
			store.state.uiVersion = 'localhost' + ' ver. 0.23.0_rubbish';
			return;
		}
		const scripts = document.scripts;
		let stop = false;
		for (const item of scripts) {
			if (!stop && item.src.includes('js/app.js') && item.src.includes(location.host)) {
				const src = item.src.split('/');
				src.forEach((element) => {
					if (!Number.isNaN(Number.parseFloat(element))) {
						const appMode = getDevice();
						store.state.uiVersion = appMode + ' ver. ' + element;
						stop = true;
					}
				});
			}
		}
	} catch (e) {
		// Too bad
	} finally {
		store.state.versionInit = true;
	}
};

export const setMenu = async () => {
	try {
		if (isApp()) {
			// don't show menu in APP-mode
			return;
		}
		if (!store.state.authenticationContext.isLoaded) {
			await store.dispatch(UPDATE_AUTH);
		}

		if (store.state.authenticationContext.authenticated) {
			// show menu
			store.state.menuModel = store.state.frontendConfiguration.menu.menuPoints;
		}
	} catch (e) {
		exception(e);
		// Too bad
	}
};
